<div class="container pb-4 pt-4 ">
  <app-breadcrumb currentRouteName="Outils"></app-breadcrumb>
  <h1 class="pt-4 pb-3">Outils</h1>
  @for (tool of tools | async | tooltype:'MAIN'; track tool) {
    <app-tool-block [tool]="tool"></app-tool-block>
  }

  <div class="tools-grid d-flex flex-wrap justify-content-center">
    @for (tool of tools | async | tooltype:'TOOL' | sort:'id':false; track tool) {
      <app-tool-block
      [tool]="tool"></app-tool-block>
    }
  </div>
</div>
